import { Box, Flex, Text, Image, VStack, Tag, SimpleGrid } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { projects } from '../data/projectsData';

const MotionBox = motion(Box);

export default function Projects() {
	const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

	const isMobile = window.innerWidth <= 768;

	return (
		<Flex
			id="portfolio"
			flexDirection="column"
			padding="5%"
			paddingLeft="10%"
			paddingRight="10%"
			backgroundColor="black.300"
			minW="100%"
		>
			<Text
				fontSize="4xl"
				fontFamily="Source Code Pro Variable"
				fontWeight="600"
				color="white.200"
				marginBottom="5%"
				width={"100%"}
				textAlign={"center"}
			>
				Portfolio
			</Text>

			<SimpleGrid columns={{ base: 1, md: 5 }} spacing={4}>
				{projects.map((project, index) => (
					<MotionBox
						key={index}
						height="300px"
						gridColumn={{ md: getGridColumn(index) }}
						initial={{ opacity: 0, y: 50 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true, amount: 0.2 }}
						transition={{ duration: 0.5, delay: index * 0.1 }}
						onMouseEnter={() => setHoveredIndex(index)}
						onMouseLeave={() => setHoveredIndex(null)}
					>
						{/* Navigate to project details */}
						<RouterLink
							to={`/projects/${project.id}`}
							style={{ height: '100%', textDecoration: 'none' }}
						>
							<Box position="relative" overflow="hidden" borderRadius="lg" height="100%">
								<Image
									src={project.image}
									alt={project.title}
									objectFit="cover"
									width="100%"
									height="100%"
									transition="transform 0.3s ease"
									transform={!isMobile && hoveredIndex === index ? "scale(1.05)" : "scale(1)"}
								/>
								<Box
									position="absolute"
									top="0"
									left="0"
									right="0"
									bottom="0"
									bg="rgba(0,0,0,0.7)"
									opacity={!isMobile && hoveredIndex === index ? 1 : 0}
									transition="opacity 0.3s ease"
									display="flex"
									alignItems="center"
									justifyContent="center"
								>
									<VStack spacing={4}>
										<Text fontSize="2xl" fontWeight="bold" color="white">
											{project.title}
										</Text>
										<Text fontSize="md" color="gray.300" textAlign="center" px={4} width={"80%"}>
											{project.description}
										</Text>
										<Flex
											gap={2}
											wrap={"wrap"}
											width={"80%"}
											justifyContent={"center"}
										>
											{project.tags.map((tag, tagIndex) => (
												<Tag key={tagIndex} colorScheme="blue" textColor={"white"}>
													{tag}
												</Tag>
											))}
										</Flex>
									</VStack>
								</Box>
							</Box>
						</RouterLink>
					</MotionBox>
				))}
			</SimpleGrid>
		</Flex>
	);
}

function getGridColumn(index: number) {
	const pattern = [
		"span 3",	// First item spans 3 columns
		"span 2",	// Second item spans 2 columns
		"span 2",	// Third item spans 2 columns
		"span 3",	// Fourth item spans 3 columns
	];
	return pattern[index % pattern.length];
}